// Third-party
import React, { Component } from 'react';
import { Form } from 'formik';

// Components
import { CancelButton, PrimaryButton } from '../buttons';

// Utils
import { FormattedMessage } from '../../../utils/i18n';
import { AutoCompleteInput } from '../inputs';
import { AutoCompleteResult } from '../inputs/AutoCompleteInput';
import { getEnterpriseGroup } from '../../../utils/enterprise';
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';
import EnterpriseGroup from '@/types/enterprise-group';

interface ParentProps {
  onAddMember: (memberId: string) => void;
  onCancel: () => void;
}

type Props = ParentProps & {
  adminDetails: EnterpriseAdminDetails;
  group: EnterpriseGroup;
};

type State = {
  res: AutoCompleteResult[];
  selection?: AutoCompleteResult;
};

class AddEnterpriseGroupMemberForm extends Component<Props, State> {
  static defaultProps = {
    onCancel: () => {},
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      res: [],
      selection: undefined,
    };
  }

  onSearch = (query: string): Promise<void> => {
    const { group, adminDetails } = this.props;

    const enterpriseGroup = getEnterpriseGroup(adminDetails);

    // use first group as it must be 'Enterprise'
    const members = enterpriseGroup.members.filter(member => group.members.find(m => member._id === m._id) === undefined);

    const localQuery = query.toLowerCase();
    const res: AutoCompleteResult[] = members.reduce((acc, m) => {
      if (
        (m.fname != null && m.fname.toLowerCase().includes(localQuery)) ||
        (m.lname != null && m.lname.toLowerCase().includes(localQuery)) ||
        m.email.includes(localQuery)
      ) {
        acc.push({ _id: m._id, text: `${m.fname != null ? m.fname : ''} ${m.lname != null ? m.lname : ''} (${m.email})` });
      }
      return acc;
    }, [] as AutoCompleteResult[]);

    this.setState({ res });
    return Promise.resolve();
  };

  onSelect = (item: AutoCompleteResult) => {
    this.setState({ res: [], selection: item });
  };

  onClick = () => {
    const { selection } = this.state;
    if (selection != null) {
      this.props.onAddMember(selection._id);
    }
  };

  render() {
    const { selection } = this.state;

    return (
      <div className="settings-enterprise-add-member section align-items-center">
        <Form>
          <AutoCompleteInput results={this.state.res} onSearch={this.onSearch} onSelect={this.onSelect} />

          <div>{selection && selection.text}</div>

          <div className="form-actions d-flex justify-content-end">
            <CancelButton onClick={this.props.onCancel} />

            <PrimaryButton onClick={this.onClick} disabled={selection == null}>
              <FormattedMessage id="Admin.Enterprise.AddMemberBtn" />
            </PrimaryButton>
          </div>
        </Form>
      </div>
    );
  }
}

export default AddEnterpriseGroupMemberForm;
